export default {
  country: null,
  firstName: '',
  secondName: '',
  patronymic: '',
  birthDate: '',
  placeOfBirth: '',
  documentId: '',
  documentIssueDate: '',
  insuranceNumber: '',
  rejectionReason: null,
};
